import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _DebugState;
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export class DebugState {
  constructor() {
    _defineProperty(this, "_isEnabled", false);
  }
  static initializeFromQueryParams(queryParams) {
    if (queryParams && queryParams[DebugState.DEV_DEBUG_PARAM]) {
      DebugState._instance.isEnabled = queryParams[DebugState.DEV_DEBUG_PARAM];
    }
  }
  static get instance() {
    return DebugState._instance;
  }

  // Commented out because @Bindable is legal only in AbGelato, and no one was listening.
  // @Bindable
  get isEnabled() {
    return this._isEnabled;
  }
  set isEnabled(value) {
    this._isEnabled = value;
  }
}
_DebugState = DebugState;
_defineProperty(DebugState, "DEV_DEBUG_PARAM", "ab_devtools");
_defineProperty(DebugState, "_instance", new _DebugState());
//# sourceMappingURL=DebugState.js.map
